import DsTooltip from './src/DsTooltip';

/* istanbul ignore next */
DsTooltip.install = function(Vue) {
    Vue.component(DsTooltip.name, DsTooltip);
};

export default DsTooltip;
